import { render, staticRenderFns } from "./Myfile.vue?vue&type=template&id=77883c27&scoped=true&"
import script from "./Myfile.vue?vue&type=script&lang=js&"
export * from "./Myfile.vue?vue&type=script&lang=js&"
import style0 from "./Myfile.vue?vue&type=style&index=0&id=77883c27&lang=less&scoped=true&"
import style1 from "./Myfile.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77883c27",
  null
  
)

export default component.exports